import { useApolloClient } from '@apollo/client';
import { MediaAdCampaignDocument } from '@shared/api/graphql/generated';
import type { MediaAdCampaignQuery } from '@shared/api/graphql/generated';

export const useAdCampaignRefresh = () => {
  const client = useApolloClient();
  return async (adCampaignId: string) => {
    const response = await client.query<MediaAdCampaignQuery>({
      query: MediaAdCampaignDocument,
      variables: { adCampaignId },
      fetchPolicy: 'network-only',
    });
    if (response.errors?.length || !response.data.adCampaignPure)
      throw new Error('Ad campaign refresh was not confirmed');
    return response.data.adCampaignPure;
  };
};
